import React from 'react';
import { withPrefix } from 'gatsby';
import Image from '../Image';
import T from '../Translation';

export default function AdoptComprehensive() {
  return (
    <a href={withPrefix('/security-operations-platform/Certego_Packages.pdf')} target="_blank" rel="noreferrer">
      <div className="flex xl:items-center xl:flex-row flex-col xl:gap-10 gap-6 bg-certego-lightgray rounded-xl px-8 py-10 max-w-250 mx-auto">
        <Image
          img="security-operations-platform/platform_services.webp"
          alt="Certego PanOptikon SecOps Platform incident response"
          className="max-w-135 w-full xl:m-0 mx-auto"
        />
        <div>
          <T tag="h2" id="platform.security-operations-platform.adopt-title" className="sub-title font-bold mb-10">
            Adopt a Comprehensive Security Solution
          </T>
          <T tag="h3" id="platform.security-operations-platform.adopt-descr">
            Discover all
            <br />
            components
          </T>
        </div>
      </div>
    </a>
  );
}
